export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-dota-faf818f9a02b51422563988307d40cb7.ogv";